export enum PersonalPath {
  HOME = '/personal',
  PROFILE = '/personal/profile',
  SERVICES = '/personal/treatments',
  SPECIALISTS = '/personal/specialists',
  CLINICS = '/personal/clinics',
  HELP = '/personal/help',
}
